"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const operators_1 = require("rxjs/operators");
const core_1 = require("@angular/core");
const forms_1 = require("@angular/forms");
const datasource_1 = require("./datasource");
const material_1 = require("@angular/material");
const _4d_mapper_1 = require("4d-mapper");
const main_service_1 = require("../main/main.service");
const Constants_1 = require("./Constants");
const moment = require('moment');
class ExplorerListComponent {
    constructor(fourD, mainService) {
        this.fourD = fourD;
        this.mainService = mainService;
        this.debug = Constants_1.Constants.debug_off;
        this.searchCont = new forms_1.FormControl();
        this.rowClicked = new core_1.EventEmitter();
        this.selectionChanged = new core_1.EventEmitter();
        this.rowRemoveClicked = new core_1.EventEmitter();
        this.onDelete = new core_1.EventEmitter();
        this.doubleClicked = new core_1.EventEmitter();
        this.photoTypeCount = new core_1.EventEmitter();
        this.startAdHoc = new core_1.EventEmitter();
        this.items = [];
        this.colNamesTemplate = ['icon', 'name', 'dataType', 'size', 'dateUpdated', 'img'];
        this.colNames = [];
        this.moment = moment;
        this.selectedFiles = [];
        this.selectedItemsMap = {};
        this.subs = [];
        this.masks = {};
        this.type_Transform = _4d_mapper_1.Transform;
        this.icons = {
            'tms': 'layer-group',
            'terrain': 'globe',
            'three-d-tiles': 'cube',
            'photo-dzi': 'image',
            'unknown': 'question-circle'
        };
        if (this.debug) {
            console.log('explorer-list :: construct()');
        }
        // search filters change
        this.subs.push(this.searchCont.valueChanges.pipe(operators_1.debounceTime(2000)).subscribe(s => {
            if (this.debug) {
                console.log('explorer-list :: sub :: value change + refresh');
            }
            this.searchQ = s;
            this.refresh(s);
        }));
        // initial column names (cloned from template)
        this.colNames = this.colNamesTemplate.slice(0);
    }
    ngOnChanges(a) {
        if (this.debug) {
            console.log('explorer-list :: ngOnChange()');
        }
        if (a.query) {
            if (this.searchQ === undefined)
                this.query = {
                    op: 'and',
                    items: [{
                            col: 'folder', op: '=', isNull: true
                        },
                        {
                            col: 'account', op: '=', val: this.fourD.activeTeam.id
                        }
                    ]
                };
            if (this.debug) {
                console.log('explorer-list :: ngOnChange() no query -> refresh', a);
            }
            this.refresh();
        }
    }
    ngOnInit() {
        if (this.debug) {
            console.log('explorer-list :: ngOnInit()');
        }
        // set up the up and down keyboard keys events
        this.boundKeyboardDown = this.keyDown.bind(this);
        this.boundKeyboardUp = this.keyUp.bind(this);
        window.addEventListener('keydown', this.boundKeyboardDown, false);
        window.addEventListener('keyup', this.boundKeyboardUp, false);
        // change of folders (? @alex)
        this.mainService.searchFilesFolder.subscribe(value => {
            if (this.debug) {
                console.log('explorer-list :: ngOnInit :: subscriber = folder change -> refresh');
            }
            if (!value)
                this.query = {
                    op: 'and',
                    items: [{
                            col: 'folder', op: '=', isNull: true
                        },
                        {
                            col: 'account', op: '=', val: this.fourD.activeTeam.id
                        }
                    ]
                };
            this.refresh(value, true);
        });
        /* this.mainService.searchFilesFolderWithoutGlobal.subscribe(value => {
           this.refresh('', false);
         });*/
        this.sort.sort(({ id: 'dateUpdated', start: 'asc' }));
    }
    ngAfterViewInit() {
        if (this.debug) {
            console.log('explorer-list :: ngAfterViewInit() :: -> refresh');
        }
        this.refresh();
    }
    clickedCheckbox(event) {
        // console.log('clickedCheckbox');
        event.stopPropagation();
    }
    clickedRow(element, col) {
        // console.log ( 'clickedRow');
        if (this.disableSelect)
            return;
        this.rowClicked.emit({ item: element, column: col });
        if (!this.masks['ctrl'] && !this.masks['shift']) {
            this.selectedItemsMap = {};
        }
        if (this.masks['shift'] && this.selectedFiles.length) {
            var from = this.selectedFiles[0];
            var i = this.dataSource.results.items.findIndex(a => a == from);
            var i2 = this.dataSource.results.items.findIndex(a => a == element);
            var fromI = Math.min(i, i2);
            var to = Math.max(i, i2);
            var ii = 0;
            this.selectedItemsMap = {};
            for (ii = fromI; ii <= to; ii++) {
                this.selectedItemsMap[this.dataSource.results.items[ii].id] = this.dataSource.results.items[ii];
            }
        }
        else {
            if (this.selectedItemsMap[element.id])
                delete this.selectedItemsMap[element.id];
            else {
                this.selectedItemsMap[element.id] = element;
            }
        }
        this.selectedFiles = Object.keys(this.selectedItemsMap).map(k => this.selectedItemsMap[k]);
        this.selectionChanged.emit(this.selectedFiles);
    }
    selectAll() {
        this.selectedItemsMap = {};
        this.selectedFiles = Object.keys(this.selectedItemsMap).map(k => this.selectedItemsMap[k]);
        this.selectionChanged.emit(this.selectedFiles);
    }
    refresh(search, isGlobalSearch) {
        if (this.debug) {
            console.log('explorer-list :: ** refresh() **');
        }
        if (!search && this.searchQ && this.searchQ.length > 0) {
            search = this.searchQ;
            // return;
        }
        this.clearSelection();
        // reset columns (with a clone of the template list)
        this.colNames = this.colNamesTemplate.slice(0);
        if (this.moreMenu) {
            this.colNames.push('$TOOLS');
        }
        var queryObj = _4d_mapper_1.Dataset;
        var vq = this.fourD.V.searchByObject(queryObj);
        if (this.query) {
            if (isGlobalSearch === undefined || isGlobalSearch === false) {
                if (this.debug) {
                    console.log('explorer-list :: refresh :: vq.complexQuery');
                }
                vq.complexQuery(this.query);
            }
        }
        if (this.debug) {
            console.log('explorer-list :: refresh :: new VasatDataSource');
        }
        this.dataSource = new datasource_1.VasatDataSource(vq, this.sort, this.paginator);
        if (search && search.length) {
            this.dataSource.searchText = {
                op: "like",
                col: "name",
                val: "~" + search + "~"
            };
        }
        else {
            this.dataSource.searchText = null;
        }
        if (this.lastSub)
            this.lastSub.unsubscribe();
        // I think the way material tables works ahs changes a bit, so not sure if this datasource object is even of any use now.
        this.lastSub = this.dataSource.connect(null).subscribe(res => {
            this.items = res;
            if (this.debug) {
                console.log('  explorer-list :: dataSource.connect.subscribe :: this.items = res', res);
            }
        });
        this.checkPhotoCount();
        Constants_1.Constants.hideHangOn();
        if (this.debug) {
            console.log('  explorer-list :: refresh done');
        }
    }
    checkPhotoCount() {
        this.dataSource.loadedSubject.subscribe(res => {
            var count = 0;
            let items = this.dataSource.getSortedData();
            if (items) {
                items.forEach(ele => {
                    if (ele instanceof _4d_mapper_1.Dataset && ele.dataType && ele.dataType.uid == 'photo') {
                        //console.log("Enter dataset name: " + ele.name)
                        count++;
                    }
                });
                this.photoTypeCount.emit(count);
            }
        });
    }
    clearSelection() {
        this.selectedFiles = [];
        this.selectedItemsMap = {};
        // console.log ( '  explorer-list :: clearSelection()');
    }
    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
        window.removeEventListener('keydown', this.boundKeyboardDown);
        window.removeEventListener('keyup', this.boundKeyboardUp);
    }
    keyDown(e) {
        if (this.disableSelect)
            return;
        // shift delete
        if (e.shiftKey && (e.keyCode == 46 || e.keyCode == 110)) {
            this.onDelete.emit(this.selectedFiles);
        }
        // ctrl + backspace (macs)
        else if ((e.ctrlKey || e.metaKey) && (e.keyCode == 8)) {
            this.onDelete.emit(this.selectedFiles);
        }
        else if ((e.ctrlKey || e.metaKey) && e.keyCode == 17 || e.keyCode == 224 || e.keyCode == 91) {
            this.masks['ctrl'] = e.keyCode;
        }
        else if (e.altKey && e.keyCode == 18) {
            this.masks['alt'] = e.keyCode;
        }
        else if (e.shiftKey && e.keyCode == 16) {
            this.masks['shift'] = e.keyCode;
        }
        else if (e.shiftKey && e.keyCode == 16) {
            this.masks['shift'] = e.keyCode;
        }
        else if ((e.ctrlKey || e.metaKey) && e.keyCode == 65) {
            this.selectAll();
            e.preventDefault();
        }
        else {
            this.masks[e.keyCode] = true;
        }
    }
    keyUp(e) {
        delete this.masks[e.keyCode];
        if (e.keyCode == 17 || e.keyCode == 224 || e.keyCode == 91) {
            delete this.masks['ctrl'];
        }
        if (e.keyCode == 18) {
            delete this.masks['alt'];
        }
        if (e.keyCode == 16) {
            delete this.masks['shift'];
        }
    }
}
exports.ExplorerListComponent = ExplorerListComponent;
